/* eslint-disable sonarjs/no-duplicate-string */
import { forwardRef, useRef } from "react";

import Grid from "@mui/material/Grid";
import { Nullable } from "@simplyk/common";

import { CompleteEmailRecipientsInput } from "./EmailRecipientsInput/CompleteEmailRecipientsInput";
import { EmailRecipientsFieldProps, EmailRecipientsInputRef } from "./types";

import { BulkProviderRef } from "@/contexts/BulkContext";

declare global {
  interface Window {
    clipboardData: { getData?: (key: string) => string };
  }
}

export const EmailRecipientsField = forwardRef(
  ({
    recipientEmails,
    updateRecipientEmails,
    onDrawerOpen,
    disabled,
    inputOnly,
    inputContainerRef,
    noValidation,
  }: EmailRecipientsFieldProps) => {
    const emailRecipientInputRef = useRef<Nullable<EmailRecipientsInputRef>>(null);

    const handleOpenDrawer = () => {
      if (disabled) {
        return;
      }

      onDrawerOpen?.();
    };

    const handleUpdateEmails = async (recipientEmails: string[]) => {
      await updateRecipientEmails?.(recipientEmails);
      bulkSelectRef.current?.resetDefaultValues(recipientEmails);
    };

    const bulkSelectRef = useRef<BulkProviderRef>(null);

    return (
      <Grid item xs={12}>
        <CompleteEmailRecipientsInput
          onChangeRecipients={handleUpdateEmails}
          disabled={disabled}
          defaultRecipientEmails={recipientEmails}
          handleOpenDrawer={handleOpenDrawer}
          inputOnly={inputOnly}
          inputContainerRef={inputContainerRef}
          noValidation={noValidation}
          ref={emailRecipientInputRef}
        />
      </Grid>
    );
  }
);

EmailRecipientsField.displayName = "EmailRecipientsField";
